module.exports = __webpack_public_path__ + "img/banner7.321ec88c.jpg";